import { useEffect, useState } from "react";
import { toast } from "material-react-toastify";
import { handleSpringDataMutationRequest } from "../../../../../app/api";

const useSubscriptions = (hotelIds = null) => {
  const queryParams = new URLSearchParams(window.location.search);
  const hotelId = queryParams.get("hotelId");
  const [subscriptionList, setSubscriptionList] = useState(null);

  useEffect(() => {
    if (!hotelId) return;

    const getSubscriptionList = async () => {
      try {
        const res = await handleSpringDataMutationRequest(
          "POST",
          `core/api/v1/subscription/get-all`,
          hotelIds ? hotelIds : [hotelId]
        );

        setSubscriptionList(res);
      } catch (err) {
        toast.error(err);
      }
    };

    getSubscriptionList();
  }, [hotelId]);

  return { subscriptionList };
};

export default useSubscriptions;
